// Roles del JWT que conceden acceso a loyalty-admin (cualquiera de ellos basta)
export const LOGIN_ROLES = ['LTY_EMB', 'LTY_ADM', 'LTY_CFG_STM']
